import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m22.527 11.79-6.64-6.64a.74.74 0 0 0-1.044 0l-.049.046-.939.94-1.043 1.044-.94.94-3.56 3.558a.74.74 0 0 0-.215.523v9.337a.74.74 0 0 0 .738.738l13.023-.02c.822-.002.886-.567.886-.74v-9.204a.74.74 0 0 0-.217-.521Zm-1.26 8.99c-.729 0-1.932.004-3.31.005-2.99.005-6.803.01-8.384.014v-8.292l3.342-3.344.94-.939L14.9 7.18l.465-.465 3.357 3.357 2.547 2.546v8.162Z" fill="currentColor"/> <path d="M12.915 5.196 11.871 6.24l-1.858-1.859-5.793 5.793v8.29l2.548-.002v1.474l-3.285.006h-.001a.736.736 0 0 1-.738-.738V9.867c0-.195.078-.382.217-.521l6.53-6.53a.743.743 0 0 1 1.044 0z" fill="currentColor"/>' }
  })
);